import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class TuitionAssistanceMyPaymentDetailsController extends Controller {
  @tracked paymentYear = '';

  queryParams = ['paymentYear'];
}
